<template>
  <div class="button-credit">
    <button type="button" class="s-btn line-btn credit-btn" @click="togglePaymentModal">
      <img src="/icons/credit.svg" alt="" />
      <p class="accent">
        {{ formatNumberWithComma(subscriptionStore.currentCredits) }}
      </p>
    </button>

    <button type="button" class="s-btn plan-btn hide-mobile" @click="navigateTo('ss-plan-manage', 'plan_setting')">
      <Tag :label="subscriptionStore.userPlan" type="gradient" />
    </button>
  </div>

  <teleport to="body">
    <SelfServicePaymentModal v-if="showPaymentModal" menu="CREDIT" @close="togglePaymentModal" />
  </teleport>
</template>

<script setup lang="ts">
import SelfServicePaymentModal from '@/components/domains/self-service/SelfServicePaymentModal.vue';
import Tag from '@/components/shared/base/Tag.vue';
import { useGtag } from '@/composables/shared/useGtag';
import { useSubscriptionStore } from '@/stores/subscription';
import { formatNumberWithComma } from '@/utils/stringUtils.js';

const props = withDefaults(
  defineProps<{
    usingAutoUpdate?: boolean;
  }>(),
  {
    usingAutoUpdate: false,
  }
);

const { t } = useI18n();
const router = useRouter();

const subscriptionStore = useSubscriptionStore();

const { trackEventClick } = useGtag();

const showPaymentModal = ref<boolean>(false);
const intervalSubscriptionId = ref<ReturnType<typeof setTimeout>>();

const navigateTo = (name: string, label: string, query: Record<string, string> = {}) => {
  if (name) {
    trackEventClick('header', t(label, {}, { locale: 'ko' }));
    router.push({ name, query });
  }
};

const togglePaymentModal = () => {
  if (!showPaymentModal.value) {
    trackEventClick('header', '크레딧');
  }

  showPaymentModal.value = !showPaymentModal.value;
};

/**
 * @desc 30초마다 구독정보를 불러옵니다.
 **/
const updateSubscriptionAutomatically = async (onOff: boolean) => {
  if (onOff) {
    intervalSubscriptionId.value = setInterval(async () => {
      await subscriptionStore.fetchSubscriptionInfo();
    }, 30000);
  } else {
    clearInterval(intervalSubscriptionId.value);
  }
};

watch(
  () => props.usingAutoUpdate,
  async (val) => {
    await updateSubscriptionAutomatically(val);
  },
  { immediate: true }
);

onUnmounted(async () => {
  clearInterval(intervalSubscriptionId.value);
});
</script>

<style scoped lang="scss">
.button-credit {
  display: flex;
  gap: 0.5rem;
  button {
    &.credit-btn {
      border-radius: 100px;
      padding-left: 4px;
      gap: 4px;
      background: initial;
    }
    &.plan-btn {
      padding: 0;
      p {
        height: 100%;
        font-size: $font-size-psmall;
        color: #fff;
      }
    }
  }
}

@media (max-width: 768px) {
  .plan-btn {
    display: none;
  }
}
</style>
